"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// average of
function avg(numbers) {
    return numbers.reduce((a, b) => a + b) / numbers.length;
}
exports.avg = avg;
// sum of
function sum(numbers) {
    return numbers.reduce((a, b) => a + b);
}
exports.sum = sum;
// median of
function med(numbers) {
    const sorted = numbers.sort((a, b) => a - b);
    if (sorted.length % 2 === 0) {
        const a = sorted.length / 2 - 1;
        const b = a + 1;
        return sorted[a] + sorted[b] / 2;
    }
    else {
        const a = (sorted[sorted.length - 1] + 1) / 2;
        return sorted[a];
    }
}
exports.med = med;
// deviation
function devia(numbers) {
    const average = avg(numbers);
    return sum(numbers.map((n) => Math.pow(n - average, 2))) / numbers.length;
}
exports.devia = devia;
// standard deviation of
function sd(numbers) {
    const average = avg(numbers);
    return Math.pow(sum(numbers.map((n) => Math.pow(n - average, 2))) / numbers.length, 1 / 2);
}
exports.sd = sd;
function nDis(x, numbers) {
    const std = sd(numbers);
    const aver = avg(numbers);
    return [(aver - (std / Math.sqrt(numbers.length)) * x), (aver + (std / Math.sqrt(numbers.length)) * x)];
}
exports.nDis = nDis;
//# sourceMappingURL=Stats.js.map